import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { CouponModal } from './coupon-modal.component';
import { QRCodeModule, RatingModule } from 'ionic4-kits';
import {PipesModule} from '../../shared/pipes/pipes.module';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        QRCodeModule,
        RatingModule,
        PipesModule
    ],
  declarations: [CouponModal],
  entryComponents: [
    CouponModal
  ],
  exports: [
    CouponModal
  ]
})
export class CouponModalModule {}
